import WillLearnDna from './WillLearnDna'

export default WillLearnDna
